export default {
	state: {
		preloader: true
	},
	getters: {
		getPreloader(state) {
			return state.preloader;
		}
	},
	mutations: {
		SET_PRELOADER(state, payload) {
			state.preloader = payload;
		}
	},
	actions: {
		actionPreloader({ commit }, payload) {
			commit('SET_PRELOADER', payload);
		}
	}
};
